import DescriptiveToolTip from './DescriptiveToolTip'

export default DescriptiveToolTip
